export const selectIsModalOpened = (state) => state.modal.opened;
/**
 *  Step Modal related selects below
 */
export const selectIsStepModalOpened = (state) => state.modal.stepModalOpened;
export const selectIsStepModalPinned = (state) => state.modal.stepModalPinned;
export const selectStepModalData = (state) => state.modal.stepModalData;
